import {Injectable} from '@angular/core';
import {saveAs} from 'file-saver-es';

@Injectable({
	providedIn: 'root'
})
export class OrderReportHelperService {

	constructor() {
	}

	saveReportAsFile(blob: Blob, reportName: string) {
		saveAs(blob, reportName)
	}
}
